import DataView from './data_view.vue'

export default {
    path: 'dataView',
    component: DataView
}
